import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-mask"
};
const _hoisted_2 = {
  class: "student-dialog"
};
const _hoisted_3 = {
  class: "form-grid"
};
const _hoisted_4 = {
  class: "full"
};
const _hoisted_5 = {
  class: "full"
};
const _hoisted_6 = {
  class: "full parent-phones"
};
const _hoisted_7 = {
  class: "parent-title"
};
const _hoisted_8 = {
  class: "parent-list"
};
const _hoisted_9 = ["onUpdate:modelValue"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "full"
};
const _hoisted_12 = {
  class: "actions"
};
const _hoisted_13 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[14] || (_cache[14] = _createElementVNode("h2", null, "新增学生", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("label", null, [_cache[8] || (_cache[8] = _createTextVNode("姓名", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.name = $event),
    placeholder: "输入姓名"
  }, null, 512), [[_vModelText, $data.form.name, void 0, {
    trim: true
  }]])]), _createElementVNode("label", null, [_cache[9] || (_cache[9] = _createTextVNode("年级", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.grade = $event),
    placeholder: "输入年级"
  }, null, 512), [[_vModelText, $data.form.grade, void 0, {
    trim: true
  }]])]), _createElementVNode("label", _hoisted_4, [_cache[10] || (_cache[10] = _createTextVNode("学校", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.school = $event),
    placeholder: "输入学校"
  }, null, 512), [[_vModelText, $data.form.school, void 0, {
    trim: true
  }]])]), _createElementVNode("label", _hoisted_5, [_cache[11] || (_cache[11] = _createTextVNode("手机号", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.phone = $event),
    placeholder: "输入电话",
    maxlength: "11"
  }, null, 512), [[_vModelText, $data.form.phone, void 0, {
    trim: true
  }]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("span", null, "家长手机号（可不填）", -1)), _createElementVNode("button", {
    type: "button",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.addParentPhone && $options.addParentPhone(...args))
  }, "+")]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.parentPhones, (phone, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "parent-row"
    }, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => $data.form.parentPhones[index] = $event,
      placeholder: "输入电话",
      maxlength: "11"
    }, null, 8, _hoisted_9), [[_vModelText, $data.form.parentPhones[index], void 0, {
      trim: true
    }]]), $data.form.parentPhones.length > 1 ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      type: "button",
      onClick: $event => $options.removeParentPhone(index)
    }, "−", 8, _hoisted_10)) : _createCommentVNode("", true)]);
  }), 128))])]), _createElementVNode("label", _hoisted_11, [_cache[13] || (_cache[13] = _createTextVNode("客户来源", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.source = $event),
    placeholder: "请输入"
  }, null, 512), [[_vModelText, $data.form.source, void 0, {
    trim: true
  }]])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
    class: "primary",
    disabled: $data.saving,
    onClick: _cache[6] || (_cache[6] = (...args) => $options.save && $options.save(...args))
  }, "确定", 8, _hoisted_13), _createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.$emit('close'))
  }, "取消")])])]);
}